import { Stack } from '@mui/material';
import { useState } from 'react';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { LoadingView } from '@/ui/components/LoadingView';
import { LoadingViewFullScreen } from '@/ui/components/LoadingViewFullScreen';

export function LoadingViewDemo() {
  const [openLoadingView, setOpenLoadingView] = useState(false);
  return (
    <Stack sx={{ alignItems: 'start', gap: 2 }}>
      Loading view component :
      <LoadingView />
      Loading view component with custom text :
      <LoadingView text="Loading... custom text 💄" />
      Full screen loading view that lock user interaction :
      <FSPrimaryButton
        onClick={() => {
          setOpenLoadingView(true);
          setTimeout(() => {
            setOpenLoadingView(false);
          }, 2000);
        }}
      >
        Loading view full screen - 2 seconds
      </FSPrimaryButton>
      <LoadingViewFullScreen open={openLoadingView} text="wait 2 sec" />
    </Stack>
  );
}
